import { ref } from "vue";
import { LD_FLAG_IDEA_MDP_503_VIEW_AS } from "@components/constants/launchDarklyFlagKeys";

/**
 * Shared LD flag for ER-10317 so EmployeeLineMenu rows on the listing
 * update when the flag resolves (UniversalTable prop plumbing is not reliable).
 */
export const viewAsLdEnabled = ref(false);

let loadPromise = null;

export async function loadViewAsFeatureFlag(getFlag) {
  if (typeof getFlag !== "function") {
    return viewAsLdEnabled.value;
  }
  if (!loadPromise) {
    loadPromise = Promise.resolve()
      .then(() => getFlag(LD_FLAG_IDEA_MDP_503_VIEW_AS, false))
      .then((value) => {
        viewAsLdEnabled.value = value === true;
        return viewAsLdEnabled.value;
      })
      .catch(() => {
        viewAsLdEnabled.value = false;
        return false;
      });
  }
  return loadPromise;
}

export function setViewAsFeatureFlag(enabled) {
  viewAsLdEnabled.value = enabled === true;
}
